import { ZmartaAnalytics } from '@ocp-zmarta/zmarta-analytics'

let ZGA

export function getZmartaAnalytics ({
  market,
  brand,
  product,
  productFamily,
  silence
}) {
  if (ZGA && market === ZGA.market && brand === ZGA.brand) {
    return ZGA
  }

  ZGA = new ZmartaAnalytics({
    market,
    brand,
    product,
    productFamily,
    silence,
    environment: process.env.NODE_ENV
  })

  return ZGA
}
